export const DISPLAY_SIZE = {
    MOBILE: '375px',
    TABLET: '768px',
    SMALL_DESKTOP: '1024px',
    DESKTOP: '1440px',
    LARGE_DESKTOP: '1920px',
};
